import type React from "react";

interface IdProps {
  children?: React.ReactNode;
}

export function Id({ children }: IdProps): React.ReactNode {
  return <pre className="rounded-xs bg-background-secondary px-space-xs font-mono">{children}</pre>;
}
